import http from '../utils/http';
import i18n from '@/main';

export default {
    atribuirAtalhos(data) {
        return http.post({
            url: '/atalhos',
            data,
            lockMessage: i18n.t('mensagens.sistema.confirmandoAlteracaoDeAtalhos')
        });
    },

    buscarAtalhos() {
        return http.get({
            url: '/atalhos',
            lockScreen: false
        });
    },

    buscarAtalhosAgrupadosPorCategoria() {
        return http.get({ url: '/atalhos/agrupado-categoria' });
    }
};
